<template>
  <v-container class="pt-8">

    <v-row dense justify="center" align="center">
      <!-- Avatar -->
      <v-col :cols="($vuetify.breakpoint.xsOnly) ? 5 : 3" align-self="center" justify-self="center">
        <patient-avatar-upload v-model="user"/>
      </v-col>
      <!-- Form -->
      <v-col :cols="($vuetify.breakpoint.xsOnly) ? 12 : 7">
        <patient-cadastre-form />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import PatientCadastreForm from '@/components/cadastre/PatientCadastreForm';
import PatientAvatarUpload from '@/components/general/PatientAvatarUpload';

export default {
  data: () => ({
    user: null,
  }),
  created() {
    this.user = this.$store.getters['auth/getUser'];
  },
  components: {
    PatientCadastreForm,
    PatientAvatarUpload,
  },
};
</script>
